import React from 'react';
import { Crown } from 'lucide-react';
import { pickLocalizedText } from '../../../utils/localizedContent';

export default function KnockoutBracketView({ bracket, hasEventsPermission, onSelectMatch, lang, participantsById = {} }) {
  const text = (es, en) => pickLocalizedText(lang, es, en);
  return (
    <div className="overflow-x-auto">
      <div className="flex gap-8 min-w-[600px] pb-4">
        {Object.entries(bracket?.rounds || {})
          .sort(([a], [b]) => Number(a) - Number(b))
          .map(([roundNum, matches]) => (
            <div key={roundNum} className="flex-1 min-w-[200px]">
              <h4 className="text-primary font-bold mb-4 text-sm text-center">{text('Ronda', 'Round')} {roundNum}</h4>
              <div className="space-y-4">
                {matches.map((match) => {
                  const canReport = hasEventsPermission && match.status === 'pending' && match.player1?.user_id && match.player2?.user_id;
                  const p1 = match.player1 || {};
                  const p2 = match.player2 || {};
                  const full1 = participantsById[p1.user_id] || {};
                  const full2 = participantsById[p2.user_id] || {};
                  const avatar1 = full1.avatar;
                  const avatar2 = full2.avatar;
                  const initial1 = (full1.name || p1.name || 'T').charAt(0).toUpperCase();
                  const initial2 = (full2.name || p2.name || 'T').charAt(0).toUpperCase();
                  return (
                    <div key={match.match_id} className={`bg-card border rounded-xl overflow-hidden ${match.status === 'completed' ? 'border-emerald-500/30' : 'border-border'}`}>
                      <div className="p-3 flex items-center justify-between">
                        <div className="flex items-center gap-2 min-w-0">
                          <div className="w-7 h-7 rounded-full bg-[#111827] border border-white/10 overflow-hidden flex items-center justify-center text-[11px] text-white">
                            {avatar1 ? (
                              <img src={avatar1} alt={full1.name || p1.name || 'Player 1'} className="w-full h-full object-cover" />
                            ) : (
                              initial1
                            )}
                          </div>
                          <span className="text-foreground text-sm truncate">{p1.name || 'TBD'}</span>
                        </div>
                        <span className="text-muted-foreground text-sm">{match.status === 'completed' ? match.score_p1 : '-'}</span>
                      </div>
                      <div className="border-t border-border/60" />
                      <div className="p-3 flex items-center justify-between">
                        <div className="flex items-center gap-2 min-w-0">
                          <div className="w-7 h-7 rounded-full bg-[#111827] border border-white/10 overflow-hidden flex items-center justify-center text-[11px] text-white">
                            {avatar2 ? (
                              <img src={avatar2} alt={full2.name || p2.name || 'Player 2'} className="w-full h-full object-cover" />
                            ) : (
                              initial2
                            )}
                          </div>
                          <span className="text-foreground text-sm truncate">{p2.name || 'TBD'}</span>
                        </div>
                        <span className="text-muted-foreground text-sm">{match.status === 'completed' ? match.score_p2 : '-'}</span>
                      </div>
                      {canReport && (
                        <div className="border-t border-border p-2">
                          <button onClick={() => onSelectMatch(match)} className="w-full text-xs text-primary hover:bg-primary/10 py-1 rounded">
                            {text('Reportar resultado', 'Report Result')}
                          </button>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
      </div>
      {bracket?.status === 'completed' && bracket?.standings?.[0] && (
        <div className="mt-6 pt-6 border-t border-border text-center">
          <Crown size={40} className="mx-auto text-primary mb-3" />
          <h4 className="text-primary font-bold">{text('Campeon', 'Champion!')}</h4>
          <p className="text-2xl font-black text-foreground mt-2">{bracket.standings[0].player?.name}</p>
        </div>
      )}
    </div>
  );
}
